import React, {Fragment} from 'react';
import {StepperContainer, Step, Connector, StepStatus} from './styles';
import { ReactComponent as SuccessIcon } from '../../assets/icons/rounded_success_sm.svg';

type StatusStepperProps = {
    steps: string[];
    currentStep: number;
};

export const StatusStepper = ({ steps, currentStep } : StatusStepperProps) => {

    const defineStatusStep = (currentStep: number, selectedStep: number) : StepStatus => {
        if(currentStep === selectedStep){
            return 'active'
        }
        if(currentStep < selectedStep){
            return 'done'
        }
        return 'pending'
    }

    return (
        <StepperContainer>
            {steps.map((step, index) => (
                <Fragment key={step}>
                    <Step status={defineStatusStep(index, currentStep)}>
                       {index < currentStep && <SuccessIcon style={{ marginRight: '8px' }} />}
                        {step}
                    </Step>
                    {index < steps.length - 1 && <Connector />}
                </Fragment>
            ))}
        </StepperContainer>
    );
};
